const fiveLinkageRouter = {
  path: "/fiveLinkage", //主体
  name: "fiveLinkage",
  redirect: "/socialWorkerManage",
  component: () => import("../views/fiveLinkage/main"),
  children: [
    {
      path: "/socialWorkerManage",
      name: "socialWorkerManage",
      mate: {
        title: "社区社工管理"
      },
      component: () => import("../views/fiveLinkage/socialWorkerManage/index")
    },
    {
      path: "/socialOrg",
      name: "socialOrg",
      mate: {
        title: "社会组织"
      },
      component: () => import("../views/fiveLinkage/socialOrg/index"),
      redirect: "/socialOrgManage",
      children: [
        {
          path: "/socialOrgManage",
          name: "socialOrgManage",
          mate: {
            title: "社会组织管理"
          },
          component: () =>
            import("../views/fiveLinkage/socialOrg/socialOrgManage")
        },
        {
          path: "/addOrg",
          name: "addOrg",
          mate: {
            title: "新增组织"
          },
          component: () => import("../views/fiveLinkage/socialOrg/addOrg")
        }
      ]
    },
    // 新增数据字典模块
    {
      path: "/dictionary",
      name: "dictionary",
      mate: {
        title: "数据字典"
      },
      component: () => import("../views/fiveLinkage/dictionary/index"),
      redirect: "/certificateNameFive",
      children: [
        {
          path: "/certificateNameFive",
          name: "certificateNameFive",
          mate: {
            title: "证书名称"
          },
          component: () =>
            import("../views/fiveLinkage/dictionary/certificateNameFive")
        },

        {
          path: "/certificateTypeFive",
          name: "certificateTypeFive",
          mate: {
            title: "证书类型"
          },
          component: () =>
            import("../views/fiveLinkage/dictionary/certificateTypeFive")
        }
      ]
    }
  ]
}

export default fiveLinkageRouter
